import InvestmentSimulationError from './InvestmentSimulationError';
class MinimumBricksForSaleError extends InvestmentSimulationError {
    numberOfBricks;
    constructor(numberOfBricks, options) {
        super('The minimum number of bricks for sale is invalid', options);
        this.numberOfBricks = numberOfBricks;
    }
}
export default MinimumBricksForSaleError;
